/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Compensation_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Number of Frames" |
*
* @param {Timing_Sync_Compensation_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_compensation_placeholder = /** @type {((inputs?: Timing_Sync_Compensation_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Compensation_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre d'images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der Frames")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di fotogrammi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレーム数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़्रेमों की संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de quadros")
	return /** @type {LocalizedString} */ ("Number of Frames")
});